<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>

<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.clients.associations.associationDialog.title' | translate }}</div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <form [formGroup]="associationForm" autocomplete="off" class="dialog-form scroll-content-padding df-c gap15">
        <div class="fields-container">
            <mat-form-field *ngIf="!data.edit" appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 200px; min-width: 200px; max-width: 200px">
                <mat-label>{{ 'modules.clients.associations.associationDialog.labels.type' | translate }}</mat-label>
                <mat-select class="select-panel" disableOptionCentering="true" formControlName="type" panelClass="dialog-select-panel">
                    <mat-option [value]="'HOUSING_COOP'">{{ 'modules.clients.associations.types.HOUSING_COOP' | translate }}</mat-option>
                    <mat-option [value]="'PRIVATE_SECTOR_COOP'">{{ 'modules.clients.associations.types.PRIVATE_SECTOR_COOP' | translate }}</mat-option>
                    <mat-option [value]="'GARAGE_COOP'">{{ 'modules.clients.associations.types.GARAGE_COOP' | translate }}</mat-option>
                    <mat-option [value]="'HOUSING_OFFICE'">{{ 'modules.clients.associations.types.HOUSING_OFFICE' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 150px; min-width: 150px; max-width: 150px">
                <mat-label>{{ 'modules.clients.associations.associationDialog.labels.code' | translate }}</mat-label>
                <input autocomplete="chrome-off" formControlName="code" inputmode="numeric" matInput maxlength="10" type="text">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 200px; min-width: 200px; max-width: 200px">
                <mat-label>{{'Тип особи' | translate}}</mat-label>
                <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="companyType">
                    <mat-option [value]="'LEGAL'">{{'modules.billing.companies.companyTypes.LEGAL' | translate}}</mat-option>
                    <mat-option [value]="'INDIVIDUAL'">{{'modules.billing.companies.companyTypes.INDIVIDUAL' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
            <mat-label>{{ 'modules.clients.associations.associationDialog.labels.name' | translate }}</mat-label>
            <input autocomplete="chrome-off" formControlName="name" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
            <mat-label>{{ 'modules.clients.associations.associationDialog.labels.city' | translate }}</mat-label>
            <input [matAutocomplete]="citiesAutocomplete" autocomplete="chrome-off" formControlName="city" matInput type="text">
            <mat-autocomplete #citiesAutocomplete="matAutocomplete" (optionSelected)="cityIsSelected()" [displayWith]="displayCityFn" class="custom-autocomplete-panel">
<!--                matTooltip="{{'modules.references.katottg.category.' + city.category  | translate}}"-->
<!--                matTooltipClass="tooltip"-->
                <mat-option *ngFor="let city of katottgList$ | async" [value]="city" class="multiline-option" >
                    <span>{{ city.name }}</span>
                    <span>{{ city.description }}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div class="df gap20">
            <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
                <mat-label>{{ 'modules.clients.associations.associationDialog.labels.street' | translate }}</mat-label>
                <input [matAutocomplete]="streetsAutocomplete" [readonly]="!associationForm.get('city')?.value.id" autocomplete="chrome-off" formControlName="street"
                       matInput type="text">
                <mat-autocomplete #streetsAutocomplete="matAutocomplete" (optionSelected)="streetIsSelected()" [displayWith]="displayStreetFn" class="custom-autocomplete-panel">
                    <mat-option *ngFor="let street of streets$ | async" [value]="street" class="multiline-option">
                        <span>{{ street.name }}</span>
                        <span>{{ 'common.streetTypes.' + street.type | translate }}</span>
                    </mat-option>
                </mat-autocomplete>
                <div class="field-action-button">
                    <button (click)="openListDialog()" class="item-action-button gray">
                        <mat-icon>list</mat-icon>
                    </button>
                </div>
            </mat-form-field>

            <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 150px; min-width: 150px; max-width: 150px">
                <mat-label>{{ 'modules.clients.associations.associationDialog.labels.number' | translate }}</mat-label>
                <input autocomplete="chrome-off" formControlName="number" matInput type="text">
            </mat-form-field>
        </div>

        <div class="df gap15 ai-c jc-s">
            <span class="dialog-subtitle-label">{{ 'modules.clients.associations.associationDialog.labels.settings' | translate }}</span>
            <mat-divider class="grow"></mat-divider>
        </div>

        <div class="df-c">
            <mat-checkbox
                    class="form-check-box"
                    formControlName="financeEnabled"
            >
                {{ 'modules.clients.associations.associationDialog.labels.financeEnabled' | translate }}
            </mat-checkbox>

            <mat-checkbox
                    *ngIf="associationForm.get('type')?.value === 'PRIVATE_SECTOR_COOP' || associationForm.get('type')?.value === 'GARAGE_COOP'"
                    class="form-check-box"
                    formControlName="apartmentStreetAbsent">
                {{ 'modules.clients.associations.associationDialog.labels.apartmentStreetAbsent' | translate }}
            </mat-checkbox>

            <mat-checkbox
                    class="form-check-box"
                    formControlName="showActs"
            >
                {{ 'modules.clients.associations.associationDialog.labels.showActs' | translate }}
            </mat-checkbox>

            <mat-checkbox
                    class="form-check-box"
                    formControlName="hideAssociationGroup"
            >
                {{ 'modules.clients.associations.associationDialog.labels.hideAssociationGroup' | translate }}
            </mat-checkbox>

            <mat-checkbox
                    [disabled]="associationForm.get('type')?.value === 'HOUSING_COOP'"
                    class="form-check-box"
                    formControlName="meeting"
            >
                {{ 'modules.clients.associations.associationDialog.labels.meeting' | translate }}
            </mat-checkbox>
        </div>
    </form>
</div>
<div class="buttons-row df jc-e ai-c">
    <button (click)="submitForm()" [disabled]="associationForm.invalid" class="default-button apply-button">
        {{ 'common.save' | translate }}
    </button>
</div>
